import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { NumberInput } from '../TextInput';
import { useTranslate } from '../util';
import { Select } from './Select';
import { StyledSelectCustomField, StyledSelectCustomLabel, StyledSelectCustomNumberInput } from './SelectCustom.styled';

/*
 * showCustom in state prevents the select input from taking over
 * if the user enters a custom value that is one of the select options
 */

export function SelectCustom(props) {
  var _React$useState = React.useState(!props.options.some(function (o) {
      return o.value === props.value;
    })),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showCustom = _React$useState2[0],
    setShowCustom = _React$useState2[1];
  var idRef = React.useRef(props.id || "id".concat(Math.random()));
  var t = useTranslate();
  var customOptions = props.options.map(function (o) {
    return _objectSpread(_objectSpread({}, o), {}, {
      value: o.value.toString()
    });
  });
  customOptions.push({
    label: t('citrix-ui:custom_ellipsis'),
    value: ''
  });
  var selectValue = showCustom || !props.value ? '' : props.value.toString();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledSelectCustomField, {
    disabled: props.disabled
  }, props.children && /*#__PURE__*/React.createElement(StyledSelectCustomLabel, {
    htmlFor: idRef.current
  }, props.children), /*#__PURE__*/React.createElement(Select, {
    id: idRef.current,
    value: selectValue,
    disabled: props.disabled,
    onChange: onSelectChange,
    options: customOptions,
    "aria-label": props['aria-label'],
    "aria-labelledby": props['aria-labelledby']
  })), showCustom && /*#__PURE__*/React.createElement(StyledSelectCustomNumberInput, null, /*#__PURE__*/React.createElement(NumberInput, _extends({}, props, {
    onChange: onCustomValueChange,
    required: true
  }))));
  function onCustomValueChange(value) {
    props.onChange(value === -1 ? null : value);
  }
  function onSelectChange(value) {
    setShowCustom(!value);
    props.onChange(value ? parseInt(value, 10) : null);
  }
}